<template>
    <b-container fluid>
        <p class="text-center mx-auto">Signing you out, please wait ...</p>
    </b-container>
</template>

<script>
    import AuthorizationRepository from "../../repositories/authorization.repository";

    export default {
        components: {
            AuthorizationRepository
        },
        created() {
            this.$emit('show-loading-pop-up', 'Signing you out, please wait ...');
            let currentRoute = this.$route.params.currentroute;
            AuthorizationRepository.logout().then(res => {
                this.$emit('reset-loading-pop-up');
                this.$bvToast.toast('Logout successful, you will now be redirected to the homepage.', {
                    title: `Successful logout`,
                    variant: 'success',
                    solid: true
                });

                localStorage.setItem('signedIn', false);
                localStorage.setItem('signInExpiresAt', 0);

                this.$emit('authChanged');
                this.$router.push({
                    name: 'sign-in',
                    params: {'currentroute': currentRoute}
                });
            }).catch(error => {
                this.$emit('reset-loading-pop-up');
                console.log(error);
            })
        }
    }
</script>
